'use strict';

import Slider from "../slider/slider";

export default class ParagraphTypeSlick {
  constructor() {
    this.name = 'paragraph--type--slick';
    
    let slider = new Slider();

    // slider.initSlider($('.paragraph--type--slick .slick-wrapper > .field--name-field-slide'), 1, {
    //   showSummary: true
    // });

    slider.initSlider($('#block-rspca-homepageslider .field--name-field-sliders > .field__items'), 1, {
      showSummary: true
    });

    let imageBlocks = $(".paragraph--type--image");
    imageBlocks.map(function (k, v) {
      console.log(k);
      let carousel = $(v).find('.field--name-field-multiple-media');
      console.log(carousel.children().length);
      if (carousel.children().length > 1) {
        slider.initSlider(carousel, 1, {
          showSummary: true
        });
      }
    });

  }
}
